<template>
  <div class="router_view">
    <router-view v-if="isShowApp" v-slot="{ Component, route }">
      <div key="1">
        <keep-alive :include="storeData.keepAliveInclude">
          <component :key="route.name" v-if="route.meta.keepAlive" :is="Component" />
        </keep-alive>
      </div>
      <component :key="route.name" v-if="!route.meta.keepAlive" :is="Component" />
      <GlobalTabbar v-if="route.meta.isShowTabbar"></GlobalTabbar>
    </router-view>
    <GlobalLoading></GlobalLoading>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { store } from '@/pinia/store'
import { useCallAppHandle, useFormatAppData } from '@/hooks/useBridge'
import { checkAppHandle, checkIsNewPackage, utilGetFpPromise, utilGetUrlData, utilIsApp, utilIsIos, utilResetArr } from './utils'
import { useHideLoading, useShowLoading } from './hooks/useVant'
import { getAES } from '@/config/axios/index'
import { getDictListApi } from '@/api/global/dict'
import { dictListCodes } from '@/api/global/dict/types'
import GlobalTabbar from './components/GlobalTabbar.vue'

const storeData = store()
const isShowApp = ref(false)

onMounted(async () => {
  const isHideLoading = utilGetUrlData("isHideLoading") === "1";
  if (!isHideLoading) {
    useShowLoading()
  }
  if (utilIsApp()) {
    await appBridgeInit()
    if (await checkAppHandle('obtainDataDict')) {
      await appDictInit()
    } else {
      await initDict()
    }
  } else {
    await wxHeaderInfoInit()
    await getAES(true)
    isShowApp.value = true
  }
  useHideLoading()
  if (!utilIsApp()) {
    await initDict()
  }
})



const appDictInit = () => {
  return new Promise((resolve) => {
    useCallAppHandle('obtainDataDict', '', res => {
      const dict = useFormatAppData(res) as any[]
      utilResetArr(dict, storeData.allDict)
      resolve(true)
    })
  })
}

const wxHeaderInfoInit = async () => {
  // 微信公众号模式下，初始化appData
  try {
    const meta = {
      os: 7, //公众号
      lang: 'zh-CN',
    }
    const cid = await utilGetFpPromise()
    storeData.headerInfo['c-id'] = `h-${cid}`
    storeData.headerInfo['c-meta'] = JSON.stringify(meta)
    const rpcParam = {
      'cid': `h-${cid}`,
      'cmeta': meta
    }
    localStorage.setItem('rpcParam', JSON.stringify(rpcParam))
    storeData.isShowNewSource = false
  } catch (error) {
    console.log('wxHeaderInfoInit失败', error)
  }
}

//app初始化
const appBridgeInit = () => {
  return new Promise((resolve) => {
    useCallAppHandle('getUserToken', null, async (res) => {
      console.log('getUserToken方法返回数据', res)
      const info = useFormatAppData(res) as GlobalAppDataType
      let userInfo = {}
      if (!info.hasOwnProperty('user')) {
        userInfo = {
          user: {
            // os: utilIsIos() ? ([2, 8].includes(info.userType) ? '104004' : '104012') : ([2, 8].includes(info.userType) ? '104003' : '104011')
            os: utilIsIos() ? '104004' : '104003' //104011, 104012商户端的这俩os已废弃
          }
        }
      } else {
        userInfo = info.user
      }
      storeData.appData = { ...info, ...userInfo }
      console.log('查看storeData', storeData.appData)
      console.log('查看info', info)
      console.log('查看cmeta', utilIsIos() ? info.cmeta : JSON.parse(info.cmeta))
      if (!storeData.appData?.user?.os) {
        storeData.appData.user.os = utilIsIos() ? '104004' : '104003'
      }
      let meta = {
        os: utilIsIos() ? 9 : 8, //公众号
        lang: 'zh-CN',
        ov: '',
        bv: '',
        mfrs: ''
      }
      const metaInfo = utilIsIos() ? info.cmeta : JSON.parse(info.cmeta)
      if (metaInfo) {
        meta.ov = metaInfo.ov ? metaInfo.ov : ''
        meta.bv = metaInfo.bv ? metaInfo.bv : ''
        meta.mfrs = metaInfo.mfrs ? metaInfo.mfrs : ''
      }
      const cid = await utilGetFpPromise()
      storeData.headerInfo['c-id'] = `h-${cid}`
      storeData.headerInfo['c-meta'] = JSON.stringify(meta)
      const rpcParam = {
        'cid': `h-${cid}`,
        'cmeta': meta
      }
      localStorage.setItem('rpcParam', JSON.stringify(rpcParam))
      if (await checkIsNewPackage()) {
        console.log('我是新包')
        storeData.isShowNewSource = true
      } else {
        console.log('我是老包')
        storeData.isShowNewSource = false
      }
      setTimeout(() => {
        isShowApp.value = true
      }, 10)
      resolve(true)
      getSafeAreaBottomHeight()
    })
  })
}

// 获取顶部状态栏高度
const getPhoneStatusBarHeight = () => {
  return new Promise((resolve) => {
    try {
      useCallAppHandle('iphoneStatusBarHeight', '', res => {
        console.log('获取顶部状态栏高度', res)
        storeData.phoneStatusBarHeight = parseFloat(res.toString())
        resolve(true)
      })
    } catch (e) {
      resolve(true)
    }
  })
}

const getSafeAreaBottomHeight = () => {
  return new Promise((resolve) => {
    useCallAppHandle('safeAreaBottomHeight', '', res => {
      storeData.safeAreaBottomHeight = parseFloat(res.toString())
      resolve(true)
    })
  })
}

//所有字典初始化
const initDict = async () => {
  const res = await getDictListApi({ codes: dictListCodes })
  console.log('initDict', res.data)
  utilResetArr(res.data, storeData.allDict)
  useHideLoading()
}
</script>

<style lang="scss">
@import './assets/style/style.scss';
@import './assets/iconfont/font.css';

.pic {
  width: 30px;
  height: 30px;
}

.xx {
  width: 375px;
  height: 375px;
  background-color: #ccc;
  background-color: $colorBlue;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<style>
.van-image-preview__index {
  top: 40px !important;
}
</style>
